import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function PaymentCancelledPage() {
  const navigate = useNavigate()
  return (
    <div style={{ minHeight: '100vh', background: '#0B0F19', fontFamily: 'Poppins, sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#1A1F2E', borderRadius: 20, padding: '48px 40px', maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 24 }}>❌</div>
        <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Payment Cancelled</h1>
        <p style={{ color: '#9CA3AF', fontSize: 14, lineHeight: 1.6, marginBottom: 32 }}>
          Your payment was cancelled. No charges have been made. You can try again whenever you're ready.
        </p>
        <button
          onClick={() => navigate('/checkout')}
          style={{ background: '#FF7F32', color: '#fff', fontWeight: 700, fontSize: 15, padding: '14px 32px', borderRadius: 10, border: 'none', cursor: 'pointer', marginBottom: 12, width: '100%' }}>
          Try Again
        </button>
        <a href="https://subscribe.inkcrediblestudios.com"
          style={{ color: '#9CA3AF', fontSize: 13, textDecoration: 'none', display: 'block' }}>
          ← Back to website
        </a>
      </div>
    </div>
  )
}
